import React, { useEffect, useState } from 'react';
import * as moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Card, Row, Col } from 'antd';
import { IoTrashOutline, IoCheckmark, IoCheckmarkDone } from 'react-icons/io5';
import { CalendarTwoTone, ClockCircleTwoTone } from '@ant-design/icons';
import AvatarImage from '../cp-account-image';
import { getUserNotificationsList, updateUserNotifications } from '../../actions/api-actions';
import { Message } from '../cp-messages/cp-message';
import { messageConstant, notificationsConstant } from '../../constants';
import {
  getLoginAccountId,
  getLoginBusinessId,
  setTxnNotificationModalData,
} from '../../services/auth-details-service';
import { basePath } from '../../utilities/utility';
import ModalWrapper from '../cp-modal-wrapper';
import { Button } from '../cp-buttons/cp-buttons';
import useAccountServiceHook from '../../hooks/use-account-service-hook';
import useUserInfo from '../../hooks/use-user-info';
import { getSession } from '../../services/storage-service';
import { NoDataMessage } from '../cp-no-data-message';
import './style.css';
import logger from '../../services/logger';
import HooperLoading from '../cp-spinners/cp-spinner';

const { Meta } = Card;

const NotificationsCardView = ({ open, hideDrawer }) => {
  const [notificationsData, setNotificationsData] = useState([]);
  const accountId = getLoginAccountId();
  const baseUrl = basePath();
  const [nextPageIndex, setNextPageIndex] = useState(1);
  const history = useHistory();
  const userBusinessId = getLoginBusinessId();
  const [svcType, setSvcType] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [perspectiveViewUserRole, setPerspectiveViewUserRole] = useState([]);
  const [isPerspectiveModalOpen, setIsPerspectiveViewModalOpen] = useState(false);
  const [selectedPerspectives, setSelectedPerspectives] = useState([]);
  const [selectedPerspectiveId, setSelectedPerspectiveId] = useState('');
  const [transactionId, setTransactionId] = useState('');
  const [selectedPerspectiveDetails, setSelectedPerspectiveDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);


  const { userAccountObj } = useUserInfo();
  const { accountUserServiceList } = useAccountServiceHook();

  // Get Users Notifications List
  const getNotificationsData = async () => {
    try {
      setIsLoading(true);
      const oldNotificationData = [...notificationsData];
      const response = nextPageIndex > 0 && (await getUserNotificationsList(accountId, nextPageIndex, '15'));
      if (response?.data?.statusCode === 0 && response?.data?.data && response?.data?.data?.content) {
        const newNotificationData = oldNotificationData.concat(response?.data?.data?.content);
        setNotificationsData(newNotificationData);
        setNextPageIndex(response?.data?.data?.nextPageIndex);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        logger.error('error');
      }
    } catch (error) {
      // Handle any errors that occur during the process
    }
  };

  useEffect(() => {
    if (open) {
      setNextPageIndex(1);
      setTimeout(() => {
        getNotificationsData();
      }, 100);
    }
  }, [open]);

  // Update Notifications Status
  const updateNotificationStatus = async (userId, status, accountId) => {
    const payload = {
      acctId: accountId,
      status,
    };

    const response = await updateUserNotifications(userId, payload);
    if (response?.data?.statusCode === 0) {
      if (status === 'READ' || status === 'UNREAD') {
        const notificationIndex = notificationsData.findIndex((item) => item.id === userId);

        // Ensure that the necessary properties and nested objects exist
        if (notificationIndex !== -1) {
          const updatedNotificationsData = [...notificationsData];

          if (
            updatedNotificationsData[notificationIndex]?.inbox &&
            updatedNotificationsData[notificationIndex]?.inbox[0]
          ) {
            updatedNotificationsData[notificationIndex].inbox[0].status = status;
            setNotificationsData(updatedNotificationsData);
          }
        }
      }

      if (status === 'ARCHIVE') {
        const getUserNotificationsResponse = await getUserNotificationsList(accountId, 1, '15');
        if (getUserNotificationsResponse?.data?.statusCode === 0) {
          const newNotificationData = getUserNotificationsResponse?.data?.data?.content;
          setNotificationsData(newNotificationData);
          setNextPageIndex(getUserNotificationsResponse?.data?.data?.nextPageIndex);
        }
      }
    } else {
      logger.error('error');
    }
  };

  // This "handleNotificationTitleDescription" function will format the display text and title
  const handleNotificationTitleDescription = (display, entities) => {
    display = display?.replace(/\${creator\.name}/g, entities?.creator?.name);
    display = display?.replace(/\${bizRole\.name}/g, entities?.bizRole?.name);
    display = display?.replace(/\${team\.role}/g, entities?.team?.role);
    display = display?.replace(/\${team\.title}/g, entities?.team?.title);
    display = display?.replace(/\${perspective\.title}/g, entities?.perspective?.title);
    display = display?.replace(/\${service\.title}/g, entities?.service?.title);
    display = display?.replace(/\${transaction\.txnLabel}/g, entities?.transaction?.txnLabel);
    display = display?.replace(/\${transaction\.txnId}/g, entities?.transaction?.txnId);
    display = display?.replace(/\${task\.title}/g, entities?.task?.title);
    display = display?.replace(/\${task\.taskId}/g, entities?.task?.taskId);
    return display;
  };

  // This "handleDateFormat" function will format the notification date format
  const handleDateFormat = (date) => {
    const timestamp = date;
    const formattedDate = moment(timestamp).format('D-MMM-YYYY');
    return formattedDate;
  };
  // This "handleTimeFormat" function will format the notification time format
  const handleTimeFormat = (time) => {
    const timestamp = time;
    const formattedTime = moment(timestamp).format('hh:mm A');
    return formattedTime;
  };

  // This 'handleShowNotificationsProfileImages' function will handle the users profile image
  const handleShowNotificationsProfileImages = (iconUrl, name, classValue) => {
    return (
      <div>
        {iconUrl ? (
          <>
            <AvatarImage image={iconUrl} classValue={classValue} type="IMAGE" />
          </>
        ) : (
          <AvatarImage image={name?.slice(0, 1).toUpperCase()} type="AVATAR" sizeVal={40} />
        )}
      </div>
    );
  };

  // This "handleNotificationStatus" will show the status notifications message
  const handleNotificationStatus = async (status) => {
    switch (status) {
      case notificationsConstant.STATUS.UNREAD: {
        Message({
          className: messageConstant.SUCCESS.CLASSNAME,
          type: messageConstant.SUCCESS.TYPE,
          content: notificationsConstant.SUCCESS_MESSAGE.UNREAD,
          duration: 2,
        });
        break;
      }
      case notificationsConstant.STATUS.READ: {
        Message({
          className: messageConstant.SUCCESS.CLASSNAME,
          type: messageConstant.SUCCESS.TYPE,
          content: notificationsConstant.SUCCESS_MESSAGE.READ,
          duration: 2,
        });
        break;
      }
      case notificationsConstant.STATUS.ARCHIVE: {
        Message({
          className: messageConstant.SUCCESS.CLASSNAME,
          type: messageConstant.SUCCESS.TYPE,
          content: notificationsConstant.SUCCESS_MESSAGE.ARCHIVE,
          duration: 2,
        });
        break;
      }
      default:
        break;
    }
  };

  // This useEffect is used to handle the user account perspective list for servicetype
  useEffect(() => {
    const arrayOfObjPerminssionsData = [];
    const bizAccountUserList = getSession(`${userBusinessId}_biz_Accocunt_user_obj`, true);

    if (bizAccountUserList && bizAccountUserList.objPermissions) {
      const permissions = bizAccountUserList.objPermissions[svcType];

      if (permissions && Object.keys(permissions)?.length > 0) {
        const bizTrUserRole = Object.entries(permissions);
        if (bizTrUserRole) {
          bizTrUserRole.forEach((elem) => {
            if (elem[0] !== 'config') {
              arrayOfObjPerminssionsData.push({
                key: elem[1]?.perspectiveId || '',
                label: elem[1]?.displayLabel || '',
                id: elem[0] || '',
                view: elem[1]?.view,
              });
            }
          });
        }
      }
      setPerspectiveViewUserRole(arrayOfObjPerminssionsData);
    }
  }, [svcType]);

  // This 'handleOnNotificationClick' function is used to handle the navigation for notification click
  const handleOnNotificationClick = (
    notificationType,
    serviceType,
    txnPerspectiveId,
    svcTitle,
    txnId,
    transactionRefId,
    txnNotificationTypeRefId,
  ) => {
    if (serviceType && txnPerspectiveId !== undefined) {
      const notificationsTxnData = {
        notificationType,
        isModalOpen,
        serviceType,
        txnPerspectiveId,
        svcTitle,
        txnId,
        transactionRefId,
        txnNotificationTypeRefId,
      };
      history.push({
        // pathname: `${baseUrl}/services/transactions/${serviceType}/${txnPerspectiveId}&searchText=${txnId}`,
        pathname: `${baseUrl}/services/transactions/${serviceType}/${txnPerspectiveId}`,
        state: notificationsTxnData,
      });
      setTxnNotificationModalData(notificationsTxnData);
      hideDrawer();
    }
  };

  // This 'handleOnTxnTitleClick' function is used to handle the navigation on transaction title click
  const handleOnTxnTitleClick = (serviceType, txnPerspectiveId) => {
    const txnServiceListData = accountUserServiceList(serviceType);
    const bizAccountUserServiceList = userAccountObj?.objPermissions?.[serviceType];

    if (
      bizAccountUserServiceList &&
      bizAccountUserServiceList !== undefined &&
      txnServiceListData &&
      txnServiceListData?.state === 'ACTIVE'
    ) {
      if (serviceType && txnPerspectiveId !== undefined) {
        history.push({
          pathname: `${baseUrl}/services/transactions/${serviceType}/${txnPerspectiveId}`,
          state: { svcType: serviceType },
        });
        hideDrawer();
      }
    } else {
      Message({
        className: messageConstant.ERROR.CLASSNAME,
        type: messageConstant.ERROR.TYPE,
        content: "You don't have APP access to view this!",
        duration: 2,
      });
    }
  };

  // This function will open the select perspective modal for perspectiveView
  const showModal = () => {
    if (perspectiveViewUserRole?.length > 1) {
      setIsPerspectiveViewModalOpen(true);
    }
  };

  // This function will close the select perspective modal for perspectiveView
  const hideModal = () => {
    setIsPerspectiveViewModalOpen(false);
    setSelectedPerspectives([]);
    setSelectedPerspectiveId('');
  };

  // This 'handlePerspectiveClick' will handle the select and de-select functionality of selecting the perspectives for fixed view
  const handlePerspectiveClick = (index, selectItem) => {
    if (selectedPerspectives.includes(index)) {
      setSelectedPerspectiveId(selectItem.key);
      setSelectedPerspectives(selectedPerspectives.filter((selectedIndex) => selectedIndex !== index));
      setSelectedPerspectiveDetails(selectItem.view);
    } else {
      setSelectedPerspectiveId(selectItem.key);
      setSelectedPerspectives([index]);
      setSelectedPerspectiveDetails(selectItem.view);
    }
  };

  // This function will navigate on the edit txn page on done button for fixed view table list
  const navigateOnDone = () => {
    if (selectedPerspectiveDetails?.details?.state === 'ACTIVE') {
      history.push(`${baseUrl}/services/txn/edit/${transactionId}/${svcType}/${selectedPerspectiveId}`);
      window.location.reload();
      setSelectedPerspectives([]);
      setSelectedPerspectiveId('');
      hideModal();
    } else {
      Message({
        className: messageConstant.WARNING.CLASSNAME,
        type: messageConstant.WARNING.TYPE,
        content: "You don't have access to view/update these details.",
        duration: 2,
      });
      setSelectedPerspectives([]);
      setSelectedPerspectiveId('');
      hideModal();
    }
  };

  // This is the 'modalHeader' for select perspective modal
  const selectPerspectiveModalHeader = () => {
    return (
      <>
        <Row>
          <Col span={18}>
            <h4 className="related-modal-heading">Perspectives</h4>
          </Col>
          <Col span={4}>
            <Button type="info" onClick={navigateOnDone}>
              Done
            </Button>
          </Col>
        </Row>
      </>
    );
  };

  // This will show the modal content of the select perspective modal for fixed view
  const selectPerspectiveModalContent = () => {
    return (
      <ModalWrapper
        className="select-perspective-modal"
        title={selectPerspectiveModalHeader()}
        showModal={isPerspectiveModalOpen}
        onHide={() => hideModal()}
        width="500px"
        gutter="0"
        footer=""
        zIndex="9999"
      >
        <span className="select-perspective-view-modal-text">Select below any Perspective to view the details.</span>
        <>
          {perspectiveViewUserRole?.map((item, index) => {
            return (
              <>
                <li
                  className="select-perspective-modal-list"
                  onClick={() => handlePerspectiveClick(index, item)}
                  key={item?.id}
                >
                  <div>
                    <figure>
                      {selectedPerspectives.includes(index, item) ? (
                        <img
                          className="no-inner-apps-div"
                          src={require('../../static/img/icons/checkmark-blue.png')}
                          height="50px"
                          width="50px"
                          alt="No-data"
                        />
                      ) : (
                        <>
                          <AvatarImage image={item?.label?.slice(0, 1).toUpperCase()} classValue="" type="AVATAR" sizeVal={50} />
                        </>
                      )}
                    </figure>
                  </div>
                  <div className="select-perspective-view-label-div">
                    <span>{item.label}</span>
                  </div>
                </li>
              </>
            );
          })}
        </>
      </ModalWrapper>
    );
  };

  // This 'handleOnTxnIdClick' function is used to handle the navigation on transaction id click
  const handleOnTxnIdClick = (transactionId, serviceType, txnPerspectiveId) => {
    if (perspectiveViewUserRole[0]?.view?.details?.state === 'ACTIVE') {
      if (transactionId && serviceType && txnPerspectiveId !== undefined) {
        history.push(`${baseUrl}/services/txn/edit/${transactionId}/${serviceType}/${txnPerspectiveId}`);
        hideDrawer();
      }
    } else {
      Message({
        className: messageConstant.WARNING.CLASSNAME,
        type: messageConstant.WARNING.TYPE,
        content: "You don't have access to view/update these details.",
        duration: 2,
      });
    }
  };

  return (
    <>
      {isLoading &&
        <div className="loading">
          <HooperLoading />
        </div>
      }
        <>
            {open && notificationsData?.length > 0 ? (
              <div id="scrollableNotificationsDiv" style={{ height: '100%', overflow: 'auto' }}>
                <InfiniteScroll
                  dataLength={notificationsData?.length}
              next={() => nextPageIndex > 0 && getNotificationsData()}
                  scrollableTarget="scrollableNotificationsDiv"
                  hasMore
                >
                  {notificationsData?.map((item) => {
                    return (
                      <Card
                        key={item?.id}
                        className={
                          item?.inbox[0]?.status === notificationsConstant.STATUS.UNREAD
                            ? 'notifications-card unread-notification'
                            : 'notifications-card read-notification'
                        }
                        actions={[
                          <div className="notifications-card-div">
                            {item?.entities?.service?.title ? (
                              <span
                                className="notification-action-txn-title-span"
                                onClick={() => {
                                  setSvcType(item?.entities?.service?.type);
                                  handleOnTxnTitleClick(item?.entities?.service?.type, perspectiveViewUserRole[0]?.key);
                                }}
                              >
                                {item?.entities?.service?.title}
                              </span>
                            ) : (
                              <span className="notification-action-span">--</span>
                            )}
                            {item?.entities?.transaction?.txnId ? (
                              <span
                                className="notification-action-txn-id-span"
                                onClick={() => {
                                  setSvcType(item?.entities?.service?.type);
                                  setTransactionId(item?.refId);
                                  showModal();
                                  if (perspectiveViewUserRole?.length === 1) {
                                    handleOnTxnIdClick(
                                      item?.refId,
                                      item?.entities?.service?.type,
                                      perspectiveViewUserRole[0]?.key,
                                    );
                                  }
                                }}
                              >
                                {item?.entities?.transaction?.txnId}
                              </span>
                            ) : (
                              <span className="notification-action-span">--</span>
                            )}
                          </div>,
                          <div className="notifications-card-div cursor-default">
                            <span className="notification-action-span">
                              <CalendarTwoTone /> {handleDateFormat(item?.createdOn)}
                            </span>
                            <span className="notification-action-span">
                              <ClockCircleTwoTone /> {handleTimeFormat(item?.createdOn)}
                            </span>
                          </div>,
                          <div className="notification-check-delete-div">
                            {item?.inbox[0]?.status === notificationsConstant.STATUS.UNREAD ? (
                              <span className="notification-action-check-icon">
                                <IoCheckmark
                                  className='icon_style_22'
                                  onClick={() => {
                                    handleNotificationStatus(item?.inbox[0]?.status);
                                    updateNotificationStatus(
                                      item?.id,
                                      notificationsConstant.STATUS.READ,
                                      item?.inbox[0]?.acctId,
                                    );
                                  }}
                                />
                              </span>
                            ) : (
                              <span className="notification-action-double-check-icon">
                                <IoCheckmarkDone
                                  className='icon_style_22'
                                  onClick={() => {
                                    handleNotificationStatus(item?.inbox[0]?.status);
                                    updateNotificationStatus(
                                      item?.id,
                                      notificationsConstant.STATUS.UNREAD,
                                      item?.inbox[0]?.acctId,
                                    );
                                  }}
                                />
                              </span>
                            )}
                            <span className="notification-action-delete-icon">
                              <IoTrashOutline
                                className="icon_style_22 c-red"
                                onClick={() => {
                                  handleNotificationStatus(notificationsConstant.STATUS.ARCHIVE);
                                  updateNotificationStatus(
                                    item?.id,
                                    notificationsConstant.STATUS.ARCHIVE,
                                    item?.inbox[0]?.acctId,
                                  );
                                }}
                              />
                            </span>
                          </div>,
                        ]}
                      >
                        <Meta
                          avatar={handleShowNotificationsProfileImages(
                            item?.entities?.creator?.icon,
                            item?.entities?.creator?.name,
                            'notification-profile-image',
                          )}
                          title={
                            item?.eventCat === 'TXN_FORM' && item?.eventType === 'UPDATEv2' && item?.eventType === 'TASK' ? (
                              <h5
                                className="notifications-title-heading cursor-pointer"
                                onClick={() => {
                                  setSvcType(item?.entities?.service?.type);
                                  handleOnNotificationClick(
                                    'updateTxn',
                                    item?.entities?.service?.type,
                                    item?.entities?.service?.pids
                                      ? item?.entities?.service?.pids[0]
                                      : perspectiveViewUserRole[0]?.key,
                                    item?.entities?.service?.title,
                                    item?.entities?.transaction?.txnId,
                                    item?.refId,
                                    item?.entities?.transaction?.aLogId,
                                  );
                                  setIsModalOpen(true);
                                }}
                              >
                                {handleNotificationTitleDescription(item?.title, item?.entities)}
                              </h5>
                            ) : item?.eventCat === 'ACTION_FLOW' && item?.eventType === 'TXN_ACTION' ? (
                              <h5
                                className="notifications-title-heading cursor-pointer"
                                onClick={() => {
                                  setSvcType(item?.entities?.service?.type);
                                  handleOnNotificationClick(
                                    'workflowActions',
                                    item?.entities?.service?.type,
                                    item?.entities?.service?.pids
                                      ? item?.entities?.service?.pids[0]
                                      : perspectiveViewUserRole[0]?.key,
                                    item?.entities?.service?.title,
                                    item?.entities?.transaction?.txnId,
                                    item?.refId,
                                  );
                                  setIsModalOpen(true);
                                }}
                              >
                                {handleNotificationTitleDescription(item?.title, item?.entities)}
                              </h5>
                            ) : item?.eventCat === 'TXN_FORM' && item?.eventType === 'ADD_ASSET' ? (
                              <h5
                                className="notifications-title-heading cursor-pointer"
                                onClick={() => {
                                  setSvcType(item?.entities?.service?.type);
                                  handleOnNotificationClick(
                                    'addAsset',
                                    item?.entities?.service?.type,
                                    item?.entities?.service?.pids
                                      ? item?.entities?.service?.pids[0]
                                      : perspectiveViewUserRole[0]?.key,
                                    item?.entities?.service?.title,
                                    item?.entities?.transaction?.txnId,
                                    item?.refId,
                                    item?.entities?.asset?.refId,
                                  );
                                  setIsModalOpen(true);
                                }}
                              >
                                {handleNotificationTitleDescription(item?.title, item?.entities)}
                              </h5>
                            ) : item?.eventCat === 'TXN_FORM' &&
                              (item?.eventType === 'COMMENT' || item?.eventType === 'COMMENT_UPDATE') ? (
                              <h5
                                className="notifications-title-heading cursor-pointer"
                                onClick={() => {
                                  setSvcType(item?.entities?.service?.type);
                                  handleOnNotificationClick(
                                    'addComment',
                                    item?.entities?.service?.type,
                                    item?.entities?.service?.pids
                                      ? item?.entities?.service?.pids[0]
                                      : perspectiveViewUserRole[0]?.key,
                                    item?.entities?.service?.title,
                                    item?.entities?.transaction?.txnId,
                                    item?.refId,
                                    item?.entities?.comment?.refId,
                                  );
                                  setIsModalOpen(true);
                                }}
                              >
                                {handleNotificationTitleDescription(item?.title, item?.entities)}
                              </h5>
                            ) : (
                              <h5 className="notifications-title-heading cursor-default">
                                {handleNotificationTitleDescription(item?.title, item?.entities)}
                              </h5>
                            )
                          }
                          description={handleNotificationTitleDescription(item?.display, item?.entities)}
                        />
                      </Card>
                    );
                  })}
                </InfiniteScroll>
              </div>
        ) : (<>
          {!isLoading &&
            <NoDataMessage type="NO_NOTIFICATIONS" message="No Notifications found!" />
          }

        </>)}
        {selectPerspectiveModalContent()}
      </>
    </>
  );
};

NotificationsCardView.propTypes = {
  open: PropTypes.bool,
  hideDrawer: PropTypes.func,
};

export default NotificationsCardView;
